import {defineStore} from 'pinia'

export const useDisplayOrdersStore = defineStore('displayOrders', {
    state: () => ({
        data: {}
    }),
    actions: {
        set({tableName, id, displayOrder}) {
            if (!this.data[tableName]) {
                this.data[tableName] = {}
            }
            
            this.data[tableName][id] = displayOrder
        }
    }
})